import { useEffect, useState } from 'react';
import { onLanguageChange } from '../translations';

/**
 * Hook that forces component re-render when language changes
 * Use this in any component that needs to react to language changes
 * 
 * @example
 * function MyComponent() {
 *   useTranslationUpdate();
 *   return <div>{translations('screen.key')}</div>
 * }
 */
export function useTranslationUpdate() {
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    const unsubscribe = onLanguageChange(() => {
      forceUpdate(prev => prev + 1);
    });
    return unsubscribe;
  }, []);
}
